import { ExploreTrialsPanel } from '@components/app/TreatmentPage/ExploreTrialsPanel'
import { TrialSummaryCard } from '@components/app/TrialSummaryCard'
import { TrackingSources } from '@lib/tracking/TrackingSources'
import type { TrialInAlgolia } from '@modules/trials/types/TrialInAlgolia'

export const TrialsForTreatment = ({
  drugName,
  trials,
}: {
  drugName: string
  trials: TrialInAlgolia[]
}) => {
  return (
    <div className='grid grid-cols-1 gap-8'>
      {trials.slice(0, 15).map((trial, index) => (
        <div key={`trial-${trial.nctId}`}>
          {index % 5 === 4 ? (
            // TODO: https://linear.app/withpower/issue/POW-2517/trial-summary-cards-in-treatment-page-link-to-somewhere-other-than
            <ExploreTrialsPanel treatment={drugName} />
          ) : (
            <TrialSummaryCard
              trackingSource={TrackingSources.TREATMENT_PAGE}
              trial={trial}
            />
          )}
        </div>
      ))}
    </div>
  )
}
